import VersionPage from "./VersionPage";

export default VersionPage;